import { route } from "preact-router";
import User from "../../../../services/user";
import Config from "../../config";
import MobilePage from "../../../jamibet/utils/mobile-page";

import { msg } from "@lingui/core/macro";
import { UserMenuIcon } from "../../../jamibet/mobile-templates/general";
import formatCurrency from "../../../../services/currency";

export default function Header() {
	return (
		<div class="z-10 h-12">
			<div class="fixed z-10 flex h-12 w-full bg-harif-800 text-white border-b border-harif-950">
				<div class="flex w-12 items-center justify-center p-2.5" onClick={(e) => { MobilePage.openLeftMenu(); }}>
					<HamburgerIcon />
				</div>
				<div class="flex grow items-center justify-start py-1.5 pr-2">
					<a class="flex items-center relative h-full" href="/">
						<img src={Config.logourl} alt={Config.title} style="max-width: 150px; height: 28px" />
					</a>
				</div>
				{User.isLogged() ? <LoggedUserBox /> : <GuestUserBox />}
			</div>
		</div>
	);
}


function HamburgerIcon() {
	return <svg
		class="fill-current h-7"
		viewBox="0 0 64 64"
		xmlns="http://www.w3.org/2000/svg"
		style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"
	>
		<path style="fill:none" d="M0 0h1280v800H0z" transform="translate(-1024 -192)" />
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.24765192 42.35286814)"
		/>
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.0379454 27.431458)"
		/>
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.0379454 12.51004786)"
		/>
	</svg>
}

function GuestUserBox() {
	return (
		<div class="flex shrink-0 items-center justify-center gap-0.5 pr-1 py-px">
			<LoginButton />
			<RegisterButton />
		</div>
	);
}

function LoginButton({ ...props }) {
	return <input
		type="button"
		class="form-button max-w-max min-h-[70%] py-1 px-4 grow inline-block hover:cursor-pointer bg-custom-orange text-black text-[14px] uppercase font-bold"
		{...props}
		value={window.Translation(msg`Accedi`)}
		onClick={(e) => { route('#login'); window.dispatchEvent(new Event('hashchange')); }}
	/>
}

function RegisterButton({ ...props }) {
	return <input
		type="button"
		class="form-button max-w-max min-h-[70%] py-1 px-4 grow inline-block hover:cursor-pointer bg-custom-orange text-black text-[14px] uppercase font-bold"
		{...props}
		value={window.Translation(msg`Registrati`)}
		onClick={(e) => { route('#register'); window.dispatchEvent(new Event('hashchange')); }}
	/>
}

function PlusIcon({ className }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class={className}>
			<path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
		</svg>
	);
}

function LoggedUserBox() {
	return (
		<div class="flex items-center gap-1.5 px-2.5">
			<div class="text-xs font-bold leading-tight text-right">
				<div>{formatCurrency(User.balance())} {Config.currencySymbol}</div>
				<div class="text-[10px] opacity-75">Bonus: {formatCurrency(User.bonus())} {Config.currencySymbol}</div>
			</div>
			<a class="bg-amber-600 rounded border border-amber-700 w-7 h-7 flex items-center justify-center shadow hover:bg-amber-500" href="/user/payment-gateway/deposit">
				<PlusIcon className="h-3.5 w-3.5 fill-current" />
			</a>
			<div class="flex w-8 flex-col items-center justify-center py-1" onClick={(e) => { MobilePage.openRightMenu(); }}>
				<UserMenuIcon class="h-8" />
			</div>
		</div>
	);
}
